<script setup lang="ts">
</script>

<template>
  <header>
      <div class="row items-center justify-between">
      <!-- Logo on the left -->
      <NuxtLink to="/" class="col-auto">
        <Logo />
      </NuxtLink>

      <!-- Search bar in the center -->
      <AppSearch class="col-4"/>

      <!-- Login and social icons on the right -->
      <div class="col-auto row items-center" style="padding-right: 1%;">
        <LogInOut class="col-2" />
        <div class="social-icons col-auto">
          <!-- Add any social icons here if needed -->
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
header {
  backdrop-filter: blur(10px); /* Adjust to your preference */
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  border-bottom: 1px solid var(--border-color); /* Replace with a global color var */
  background-color: rgb(0, 0, 0);
  height: 6vh;

  .container {
    display: grid;
    height: 100%;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 16px;
  }

  .section {
    display: flex;
    align-items: center;

    &.left {
      grid-column: span 4 / span 4;
      @media (min-width: 1024px) {
        margin-left: 0;
      }
    }

    &.center {
      grid-column: span 4 / span 4;
      justify-content: center;
      flex: 1;
      z-index: 1;
    }

    &.right {
      grid-column: span 4 / span 4;
      justify-content: flex-end;
      margin-right: -16px;

      .social-icons {
        display: none;
        @media (min-width: 768px) {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>
